module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("gdpr_cookie_banner", [["div",{"id":"gdpr-cookie-accept","class":"strip-notification-wrapper verification-sent","style":"-webkit-transform: translateY(0px); -ms-transform: translateY(0px); transform: translateY(0px);"},[["div",{"class":"strip-notification-content"},[["p",{},[["textNode",{"text":"Hey there! Cookies are required to use this site. Feel free to check out our Cookie Policy at any time."}]]],["div",{"class":"_flex _row-n _r-h-end _m-l-20 _flex-1"},[["button",{"id":"accept-cookies","class":"gdpr-gookie-banner-button"},[["textNode",{"text":"I don’t mind Cookies"}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/GDPR-popups/templates/gdprCookieBanner.a.tpl
// module id = 95
// module chunks = 5